import type { CannedCollectionModuleCard } from '@coursera-web/cds-labs/components/Modules/CannedCollectionModule/CannedCollectionModule';

import config from 'js/app/config';

import _t from 'i18n!nls/front-page';

const courseraPlusProps: Omit<CannedCollectionModuleCard, 'onClick'> = {
  id: 'coursera-plus-promo-unit',
  eyebrowImage: {
    url: `${config.url.imageProxyRoot}https://coursera_assets.s3.amazonaws.com/images/53405f7f3dd342ada40d32c06bbe54ab.png?auto=format%2Ccompress&dpr=2`,
  },
  headline: _t('Unlock access to 10,000+ courses with a subscription'),
  cardBackgroundImage: {
    url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/6P9DiTmdmcer8Zf7aHk2HJ/99a90ec6e9a6274d07c3f5da3b10e687/474x328-C_.png`,
  },
  ctaText: _t('Start 7-day free trial'),
  target: `${config.url.base}courseraplus`,
  backgroundColor: 'blue',
  ctaVariant: 'ghostInvert',
};

const courseraForBusinessProps: Omit<CannedCollectionModuleCard, 'onClick'> = {
  id: 'coursera-for-business-promo-unit',
  eyebrowImage: {
    url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/14081g3F8gbgO8GTXzyOIL/2e85c60ad77e294153c574bd60d8e4d4/Coursera_For_Business_-_White.png?auto=format%2Ccompress&dpr=2`,
  },
  headline: _t('Drive your business forward and empower your teams'),
  cardBackgroundImage: {
    url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/Cb3tIS562yNwOycYVtgEA/c0ae706313c23a9448476155a3dc31f7/474x328.png`,
  },
  ctaText: _t('Try Coursera for Business'),
  target: `${config.url.base}business`,
  backgroundColor: 'dark-blue',
  ctaVariant: 'ghostInvert',
};

export default function getPromoUnitProps() {
  return {
    courseraPlusProps,
    courseraForBusinessProps,
  };
}
